import { render, staticRenderFns } from "./mockUp.vue?vue&type=template&id=7894e538&scoped=true"
import script from "./mockUp.vue?vue&type=script&lang=js"
export * from "./mockUp.vue?vue&type=script&lang=js"
import style0 from "./mockUp.vue?vue&type=style&index=0&id=7894e538&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7894e538",
  null
  
)

export default component.exports